import { render, staticRenderFns } from "./BinMeasurement.vue?vue&type=template&id=3bed7eb2&scoped=true&"
import script from "./BinMeasurement.vue?vue&type=script&lang=js&"
export * from "./BinMeasurement.vue?vue&type=script&lang=js&"
import style0 from "./BinMeasurement.vue?vue&type=style&index=0&id=3bed7eb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bed7eb2",
  null
  
)

/* custom blocks */
import block0 from "./BinMeasurement.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports